import AvailabilitiesCalendarRow from './AvailabilitiesCalendarRow';

export default AvailabilitiesCalendarRow;
